import styled from "styled-components"
import { typography } from "theme"

import { ButtonProps } from "components/buttons/shared"
import { textDecoration, FontConfigurations, UNDERLINE_TEXT_CSS, REMOVE_UNDERLINE_TEXT_CSS } from "theme"
import { CTA } from "components/text"

export const TextButton = styled(CTA)<ButtonProps>`
  /* Custom styles override default */
  ${typography}
  ${textDecoration}

  background-color: transparent;
  color: ${props => props.theme.colors.seafoamBlue};
  ${UNDERLINE_TEXT_CSS}

  :disabled,
  :hover {
    ${REMOVE_UNDERLINE_TEXT_CSS}
    opacity: ${props => props.theme.reducedOpacity};
  }
  :disabled {
    cursor: initial;
  }

  ${typography}
  ${textDecoration}
`
TextButton.defaultProps = {
  as: "button",
  ...FontConfigurations.p,
  fontWeight: "bold"
}

export const TextButtonSmall = styled(TextButton)``
TextButtonSmall.defaultProps = {
  ...FontConfigurations.pSm,
  fontWeight: "normal"
}
